export default {
  CreateSettlementTitle: 'Elige una aseguradora',
  createSettlementDescription: 'Para continuar, selecciona una de las siguientes opciones',
  cutoffTitle: 'Periodo de corte',
  cutoffDescription: 'Selecciona un rango de fechas, inicio y fin',
  error: 'Ocurrió un error en la creación de la radicación',
  steper: { 
    sponsorSelection: "Selección de aseguradora",
    authorizations: "Autorizaciones"
  },
  buttons: {
    next: "Continuar",
    back: "Atrás",
    cancel: "Cancelar",
    end: "Finalizar",
    changeSponsor: "Cambiar"
  },
  title: {
    text: 'Crear radicación',
    back: 'Cancelar'
  },
  dates: {
    init: "Desde",
    final: "Hasta"
  },
  authorizations: {
    cutoffRange: "Periodo de corte",
    totalResults: "{total} resultados",
    selectedRows: "{selected} seleccionados",
    chooseTitle: "Elige las autorizaciones que quieres radicar",
    chooseDescription: "Puedes deseleccionar autorizaciones",
    selectAll: "Seleccionar todas",
    grid: {
      id: "ID",
      createdAt: "Fecha creación",
      beneficiaryName: "Beneficiario",
      memberCode: "Carnet",
      coverage: "Cobertura"
    }
  }
}